<div class="mct-flex mct-row mct-justify-between mct-items-center"  >
  <span class="title-header mb-27">{{ 'referral.referral-value-report.title' | translate | titlecase }}</span>
</div>
<div class="mb-28 mct-flex mct-row mct-justify-between mct-items-center"  >
  <button
    
    class="mct-flex atlas-btn atlas-btn-secondary mct-justify-center mct-items-center"
    type="button"
    title="{{ 'profiles.relationships.back-to-profile' | translate | uppercase }}"
    [routerLink]="['/profile', profileId]"
  >
    <i class="large-icon pi pi-angle-left"></i>
    <span>{{ 'profiles.transactions.back-to-profile' | translate | uppercase }}</span>
  </button>
</div>
<div>
  <div class="card-container w-100">
    <div *ngIf="!isLoading; else loading" class="w-100 mct-flex mct-col mct-justify-start mct-items-center"  >
      <div class="w-100">
        <h4>{{ referralValueReport.Profile.McReportName | titlecase }}</h4>
      </div>
      <div class="w-100 mct-flex mct-row mct-justify-between mct-items-start mct-gap-10"   >
        <div class="general-information mct-flex mct-col" >
          <div class="card-field-label">
            {{ 'common.personal-information.address' | translate | titlecase }}
          </div>
          <div>
            {{ referralValueReport.Profile.McAddress }}
          </div>
          <div>
            {{
              referralValueReport.Profile.McCity && (referralValueReport.Profile.McState || referralValueReport.Profile.McZip)
                ? referralValueReport.Profile.McCity + ', '
                : referralValueReport.Profile.McCity
            }}
            {{ referralValueReport.Profile.McState }} {{ referralValueReport.Profile.McZip }}
          </div>
          <div *ngIf="!(referralValueReport.Profile.McCountry?.trim() === '')">
            {{ referralValueReport.Profile.McCountry }}
          </div>
        </div>
        <div>
          <div class="card-field-label mt-10">
            {{ 'profiles.view.general.website' | translate | titlecase }}
          </div>
          <div>
            <a target="_blank" href="{{ referralValueReport.Profile.McWebsite | absoluteUrl }}">
              {{ referralValueReport.Profile.McWebsite }}
            </a>
          </div>
        </div>
        <div *ngIf="referralValueReport.Profile.McPrimaryListingDisplayName" class="general-information mct-flex mct-col" >
          <div>
            <div class="card-field-label mt-10">
              {{ 'referral.referral-value-report.primary-listing' | translate | titlecase }}
            </div>
            <div>
              {{ referralValueReport.Profile.McPrimaryListingDisplayName }}
            </div>
          </div>
          <div>
            <div class="card-field-label mt-10">
              {{ 'referral.referral-value-report.primary-listing-website' | translate | titlecase }}
            </div>
            <div>
              <a target="_blank" href="{{ referralValueReport.Profile.McPrimaryListingWebsite | absoluteUrl }}">
                {{ referralValueReport.Profile.McPrimaryListingWebsite }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-container mct-flex mct-col" >
    <div *ngIf="!isLoading; else loading" class="w-100 mct-flex mct-col mct-justify-start mct-items-start"  >
      <div class="w-100 mb-10">
        <h4>
          {{ 'referral.referral-value-report.showing-referrals-from' | translate | ucfirst }}
          <span>{{ startDate }}</span>
          {{ 'common.to' | translate | lowercase }}
          <span>{{ endDate }}</span>
        </h4>
      </div>
      <div>
        <p-checkbox name="includeBots" [(ngModel)]="includeBots" [binary]="true" (onChange)="includeBotsChange()" inputId="includeBots">
        </p-checkbox>
        <label for="includeBots">
          {{ 'referral.referral-value-report.include-bots' | translate | ucfirst }}
        </label>
      </div>
    </div>

    <div [hidden]="isLoading" class="referral-stats">
      <p-tabs class="graphs">
        <p-tabpanel>
          <div class="referral-report-container">
            <div class="referral-report-chart">
              <p-chart #monthlyGraph type="line" [data]="monthlyGraphData" [options]="monthlyGraphOptions"></p-chart>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel>
          <div class="referral-report-container">
            <div class="referral-report-chart">
              <p-chart #byTypeGraph type="bar" [data]="byTypeGraphData" [options]="byTypeGraphOptions"></p-chart>
            </div>
          </div>
        </p-tabpanel>
      </p-tabs>
    </div>
    <div *ngIf="!isLoading; else loading" class="referral-stats mct-flex mct-row mct-justify-start mct-items-end mct-gap-50"   >
      <div class="mct-flex mct-col" >
        <h1 class="referral-stat-value">{{ totalReferrals }}</h1>
        <div class="referral-stat-label">{{ 'referral.referral-value-report.total-referrals' | translate | titlecase }}</div>
      </div>
      <div class="mct-flex mct-col" >
        <h3 class="referral-stat-value" [ngClass]="{ red: totalImpressions < 50 }">{{ totalImpressions }}</h3>
        <div class="referral-stat-label">{{ 'referral.referral-value-report.total-impressions' | translate | titlecase }}</div>
      </div>
      <div class="mct-flex mct-col" >
        <h3 class="referral-stat-value" [ngClass]="{ red: totalLeads < 50 }">{{ totalLeads }}</h3>
        <div class="referral-stat-label">{{ 'referral.referral-value-report.total-leads' | translate | titlecase }}</div>
      </div>
      <div class="mct-flex mct-col" >
        <h3 class="referral-stat-value" [ngClass]="{ red: leadRate < 0.01, green: leadRate > 0.02 }">
          {{ leadRate | percent }}
        </h3>
        <div class="referral-stat-label">{{ 'referral.referral-value-report.lead-rate' | translate | titlecase }}</div>
      </div>
    </div>

    <div class="mct-flex mct-col mct-gap-10" *ngIf="showVoi"  >
      <div class="referral-stats mct-flex mct-row mct-justify-start mct-items-end mct-gap-50"   >
        <div class="mct-flex mct-col" >
          <h1 class="referral-stat-value green">{{ valueOfReferrals | currency }}</h1>
          <div class="referral-stat-label">{{ 'referral.referral-value-report.value-of-referrals' | translate | titlecase }}</div>
        </div>
        <div class="mct-flex mct-col" >
          <h1 class="referral-stat-value green">{{ valueRate | percent }}</h1>
          <div class="referral-stat-label">{{ 'referral.referral-value-report.value-on-investments' | translate | titlecase }}</div>
        </div>
      </div>
      <div class="voi-note">{{ voiNote }}</div>
      <div>{{ voiStatement }}</div>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <wl-busy [show]="true" [isLarge]="true"></wl-busy>
  </div>
</ng-template>
